/* eslint-disable no-restricted-syntax */
import activeFireThumb from '@/assets/images/layer-active-wildfire.jpg'
import activeFireFull from '@/assets/images/layer-active-wildfire-full.jpg'
import aqiThumb from '@/assets/images/layer-air-quality.jpg'
import aqiFull from '@/assets/images/layer-aqi-full.jpg'
import smokeThumb from '@/assets/images/layer-smoke.jpg'
import smokeFull from '@/assets/images/layer-smoke-full.jpg'
import privateLandThumb from '@/assets/images/layer-private-land.jpg'
import privateLandFull from '@/assets/images/layer-private-land-full.jpg'
import motoTrailsThumb from '@/assets/images/layer-moto-thumb.png'
import precipRadarThumb from '@/assets/images/layer-precip-thumb.png'
import snowmobileThumb from '@/assets/images/layer-snowmobile-thumb.png'
import motoTrailsFull from '@/assets/images/layer-moto-full.png'
import precipRadarFull from '@/assets/images/layer-precip-full.png'
import snowmobileFull from '@/assets/images/layer-snowmobile-full.png'
import fishingAreaThumb from '@/assets/images/layer-fishing-areas-thumb.png'
import fishingAreaFull from '@/assets/images/layer-fishing-areas-full.jpg'

import { MODES } from '@/fish/lib/enums'

// Defines mappings between the stylesheet layer id's, activity modes
export const FISH_ACTIVITY_MODES = Object.freeze({
  [MODES.FRESHWATER]: {
    layers: [
      {
        id: 'fishing_areas',
        label: 'Fishing Areas',
        byline: 'See verified fishing areas across thousands of waterbodies',
        component: 'fishing-areas',
        img: fishingAreaThumb,
        fullImg: fishingAreaFull,
      },
      {
        id: 'precip_radar',
        label: 'Precipitation Radar',
        byline: 'View upcoming storms and storm intensity heading your way',
        component: 'precip-radar',
        img: precipRadarThumb,
        fullImg: precipRadarFull,
      },
      {
        id: 'moto_trails',
        label: 'Motorized Trails',
        byline: 'Road and Trails with known motorized access',
        component: 'motorized-trails',
        img: motoTrailsThumb,
        fullImg: motoTrailsFull,
      },
      {
        id: 'snowmobile_trail',
        label: 'Snowmobile Trails',
        byline: 'Road and Trails with known snowmobile access',
        component: 'snowmobile-trails',
        img: snowmobileThumb,
        fullImg: snowmobileFull,
      },
      {
        id: 'private_land',
        label: 'Private Land',
        byline: 'Private land and ownership info',
        component: 'private-land',
        img: privateLandThumb,
        fullImg: privateLandFull,
      },
      {
        id: 'wildfire_active',
        label: 'Active Wildfires',
        byline: 'Near real-time data from NIFC',
        component: 'active-wildfire',
        img: activeFireThumb,
        fullImg: activeFireFull,
      },
      {
        id: 'airquality_current',
        label: 'Air Quality',
        byline: 'Identify areas with unhealthy air',
        component: 'air-quality-index',
        img: aqiThumb,
        fullImg: aqiFull,
      },
      {
        id: 'wildfire_smoke_forecast',
        label: 'Smoke Forecast',
        byline: 'Track wildfire smoke plumes',
        component: 'wildfire-smoke',
        img: smokeThumb,
        fullImg: smokeFull,
      },
    ],
    allLayers: [],
  },
})
export const FISH_LAYER_KEYS = ['layers']
